import React, {useContext, useState} from 'react';
import {Box, Input, Flex, InputGroup, InputLeftElement, Spinner} from '@chakra-ui/react';
import SearchResultsList from "./SearchResultsList";
import {PlatformBrandContext} from "../../../contexts/PlatformContext";
import {BrandSelector} from "../products/ParameterSelectionBar";
import {RiSearchLine} from "react-icons/ri";
import ThresholdSelector from "./ThresholdSelector"
import {Button, ButtonGroup} from '@chakra-ui/react'
import {NewThemeForm} from "./NewThemeForm";
import {AddExistingThemeForm} from "./AddExistingThemeForm";

export default function SearchPage() {
    const [renderSearch, setRenderSearch] = useState(false);
    const [error, setError] = useState(null);
    const [searchResults, setSearchResults] = useState([])
    const {platforms, allBrands} = useContext(PlatformBrandContext);
    const [brandsSelected, setBrandsSelected] = useState(allBrands)
    const [searchQuery, setSearchQuery] = useState('');
    const [threshold, setThreshold] = useState(0);
    const [newThemeMode, setNewThemeMode] = useState(false);
    const [addExistingThemeMode, setAddExistingThemeMode] = useState(false);
    const [filteredResultsLength, setFilteredResultsLength] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const topk = 300;

    function handleChange(event) {
        setSearchQuery(event.target.value);
    }

    function fetchResults(_searchQuery, _threshold) {
        setIsLoading(true);
        setRenderSearch(false);
        fetch(`${process.env.REACT_APP_SEARCH_API_URL}/search/doSearch`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'//`${process.env.REACT_APP_API_URL}`
            },
            body: JSON.stringify({query: _searchQuery, threshold: _threshold, topk: topk})
        }).then(res => res.json())
            .then(
                (results) => {
                    console.log("SEARCH RESULTS", results);
                    setIsLoading(false);
                    setRenderSearch(true);
                    setSearchResults(results);
                },
                (error) => {
                    setIsLoading(false);
                    setRenderSearch(false);
                    setError(error);
                }
            )
    }

    function handleSubmit(event) {
        event.preventDefault()
        fetchResults(searchQuery, threshold)
    }

    function handleThresholdUpdate(val) {
        fetchResults(searchQuery, val)
    }


    return (
        <Flex flexDirection='row'>
            <Flex flexDirection='column'>
                <Flex flexDirection='column' gap='15px' p='0px' h='40px' mx='30px' mt="24px" w='640px'>
                    <form onSubmit={handleSubmit}>
                        <InputGroup align='center' grow={0}>
                            <InputLeftElement
                                pointerEvents='none'
                                children={<RiSearchLine color='gray.300'/>}
                            />
                            <Input type='text' placeholder='Search All Reviews...' value={searchQuery}
                                   onChange={handleChange}
                                   borderRadius='10px' borderColor='rgba(0,0,0,0.45)' bg='#ffffff' h='40px'/>
                        </InputGroup>
                    </form>
                    {/*<BrandSelector brands={brandsSelected} setBrands={setBrandsSelected} availableBrands={allBrands}/>*/}

                </Flex>
                <Box pt={{base: "130px", md: "80px", xl: "80px"}} ml="35px">
                    {renderSearch ? <SearchResultsList searchResults={searchResults} error={error}
                                                       brandFilter={brandsSelected.map(x => x.brand)}
                                                       platformFilter={platforms}
                                                       setResultsLength={setFilteredResultsLength}/> : (isLoading ?
                        <Spinner size='lg' ml={'80px'}/> : null)}
                </Box>
            </Flex>
            <Box>
                <Flex flexDirection='column' pt="150px" ml="40px" position='sticky' top="0px">
                    {renderSearch ? <>
                        <ThresholdSelector threshold={threshold} setThreshold={setThreshold}
                                           handleSubmit={handleThresholdUpdate}/>
                        <ButtonGroup size='md' isAttached variant='outline' w="400px">

                            <Button bgColor={addExistingThemeMode ? '#000000' : '#FFFFFF'}
                                    color={addExistingThemeMode ? '#fff' : '#000'}
                                    _hover={{}} onClick={() => {
                                setNewThemeMode(false);
                                setAddExistingThemeMode(true);
                            }}>Add to existing Theme</Button>
                            <Button bgColor={newThemeMode ? '#000000' : '#FFFFFF'}
                                    color={newThemeMode ? '#fff' : '#000'}
                                    _hover={{}}
                                    onClick={() => {
                                        setAddExistingThemeMode(false);
                                        setNewThemeMode(true);
                                    }}>Create a new Theme</Button>
                        </ButtonGroup>
                    </> : null}
                    {newThemeMode ? <NewThemeForm query={searchQuery} resultsLength={filteredResultsLength}
                                                  searchResults={searchResults}
                                                  searchThreshold={threshold} topk={topk}/> : null}
                    {addExistingThemeMode ?
                        <AddExistingThemeForm query={searchQuery} resultsLength={filteredResultsLength}
                                              searchResults={searchResults}
                                              searchThreshold={threshold} topk={topk}/> : null}
                </Flex>
            </Box>
        </Flex>
    )
}